export default "__VITE_ASSET__8GidEGy$__"